/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet, LAYOUT_OPTIONS } from '@src/app/shared/form/field-set/field-set.component';
import { FormTextComponent } from '@src/app/shared/form/form-text/form-text.component';
import { FormDateComponent } from '@src/app/shared/form/form-date/form-date.component';
import { FormNumberComponent } from '@src/app/shared/form/form-number/form-number.component';
import { BankAccountService } from '@src/app/modules/txn/bank-account.service';
import { BankReconiliationService } from '@src/app/modules/txn/bank-reconciliation/bank-reconciliation.service';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { ReplaySubject } from 'rxjs';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { FormNavLinkComponent } from '@src/app/shared/form/form-nav-button/form-nav-link.component';
import { BankRecPageNavRoute } from '@src/app/routes/app-router';

@Component({
    selector: 'app-list',
    imports: [FormPageComponent],
    templateUrl: './list.component.html',
    styleUrl: './list.component.scss'
})
export class ListComponent extends AbstractPageComponent {
    bankSvc = inject(BankAccountService);
    bankRecSvc = inject(BankReconiliationService);
    configReady = new ReplaySubject<null>(1);
    currentUserSvc = inject(CurrentUserService);

    bankLinkField = FormNavLinkComponent.makeDetail('Bank Account', 'bankName', 'bankId',
        BankRecPageNavRoute, true
    );
    bankNameField = FormTextComponent.make('Bank Account', 'bankName', { readonly: true });
    config = new FormConfig({
        navRoute: BankRecPageNavRoute,
        docPath: 'omc-books/banking/bank-reconciliation',
        title: $localize`Bank Reconciliation`,
        help: $localize`Whatever`,
        fieldSet: new FieldSet({
            fields: [
                this.bankLinkField,
                FormTextComponent.make('OMC', 'legalName', { readonly: true }),
                FormDateComponent.make('Oldest Item', 'oldest', { readonly: true }),
                FormDateComponent.make('Newest Item', 'newest', { readonly: true }),
                FormNumberComponent.make('Items', 'items', {}, { readonly: true }),
                FormNumberComponent.makeCurrency('To Be Reconciled', 'value'),
            ],
            formLayout: LAYOUT_OPTIONS.singleCol,
        }),
        service: this.bankRecSvc,
        mode: 'list',
        configReady: this.configReady,
        allowNew: false
    });

    constructor() {
        super();
        this.subscriptions.push(this.currentUserSvc.getCurrentUser().subscribe((user) => {
            this.currentUser = user;
            this.config.docPath = user.inAgency
                ? 'omc-professional/bank-reconciliation'
                : 'omc-books/banking/bank-reconciliation'                
            this.configReady.next(null);
        }));
    }
}
